import { AnchorHTMLAttributes, ReactNode } from "react"
import { stringify } from "querystringify"
import { Link, useParams } from "react-router-dom"

import { Analytics } from "utils/analytics"
import { getCurrentStatus } from "app/AppRouter/utils"
import { FunnelStorage, isAllowedToBeBookingSource } from "modules/FunnelAnalytics"
import { NotificationSourceType } from "modules/FunnelAnalytics/interfaces"
import { useSearchParams } from "utils/customHooks"
import { APP_STATUSES } from "utils/AppStatusContext"

interface NewBookingPageLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    children: ReactNode
    hashId: string
    query?: Record<string, string>
    position?: string
    from?: APP_STATUSES
    fromLink?: string
    state?: Record<string, string | number | undefined>
}

export function useGetEmailSource(): NotificationSourceType | undefined {
    const searchParams = useSearchParams()
    return (searchParams.get("email_source") ?? undefined) as NotificationSourceType | undefined
}

export function NewBookingPageLink({
    hashId,
    query,
    position = "1",
    children,
    from,
    fromLink,
    state,
    ...props
}: NewBookingPageLinkProps) {
    const pathParams = useParams<{ id: string }>()
    const urlParams: Record<string, string> = {
        ...query,
        hash_id: hashId,
        position,
    }
    if (from) {
        urlParams.from = from
    }

    if (fromLink) {
        urlParams.from_link = fromLink.toString()
    }

    const currentStatus = getCurrentStatus()
    const emailSource = useGetEmailSource()
    function clickHandler() {
        if (currentStatus) {
            Analytics.tobook_clicked({ from: currentStatus })
            isAllowedToBeBookingSource(currentStatus) &&
                FunnelStorage.getInstance().saveItem(
                    currentStatus,
                    currentStatus === APP_STATUSES.psy_collection ? pathParams.id : undefined,
                    currentStatus === APP_STATUSES.profile ? emailSource : undefined
                )
        }
    }

    return (
        <Link
            to={{
                pathname: `/booking`,
                search: `?${stringify(urlParams)}`,
            }}
            onClick={clickHandler}
            state={state}
            {...props}
        >
            {children}
        </Link>
    )
}
